import { Business } from '@square/dashboard-protos/models/squareup/legalentities/model/model';
import { KybBusinessType } from '@square/dashboard-protos/models/squareup/bbqualifier/kyb_model';

// Re-export the legalentities type enum so we can use a much more specific
// name for the enum.

export const LegalEntitiesBusinessEntityType = Business.Structure.Type;
export const NonIndividualLegalEntitiesBusinessEntityType = {
  S_CORPORATION: LegalEntitiesBusinessEntityType.S_CORPORATION,
  C_CORPORATION: LegalEntitiesBusinessEntityType.C_CORPORATION,
  LIMITED_LIABILITY_COMPANY: LegalEntitiesBusinessEntityType.LIMITED_LIABILITY_COMPANY,
  PARTNERSHIP: LegalEntitiesBusinessEntityType.PARTNERSHIP,
  COOPERATIVE: LegalEntitiesBusinessEntityType.COOPERATIVE,
  NONPROFIT: LegalEntitiesBusinessEntityType.NONPROFIT
};
export function fromCheckingKybBusinessType(kybBusinessType) {
  switch (kybBusinessType) {
    case KybBusinessType.LIMITED_LIABILITY_COMPANY:
      return LegalEntitiesBusinessEntityType.LIMITED_LIABILITY_COMPANY;
    case KybBusinessType.SOLE_PROPRIETORSHIP:
      return LegalEntitiesBusinessEntityType.SOLE_PROPRIETORSHIP;
    case KybBusinessType.C_CORPORATION:
      return LegalEntitiesBusinessEntityType.C_CORPORATION;
    case KybBusinessType.S_CORPORATION:
      return LegalEntitiesBusinessEntityType.S_CORPORATION;
    case KybBusinessType.PARTNERSHIP:
      return LegalEntitiesBusinessEntityType.PARTNERSHIP;
    case KybBusinessType.NONPROFIT:
      return LegalEntitiesBusinessEntityType.NONPROFIT;
    case KybBusinessType.UNKNOWN_KYB_BUSINESS_TYPE:
    default:
      return undefined;
  }
}
export function toCheckingKybBusinessType(legalEntitiesBusinessType) {
  switch (legalEntitiesBusinessType) {
    case LegalEntitiesBusinessEntityType.LIMITED_LIABILITY_COMPANY:
      return KybBusinessType.LIMITED_LIABILITY_COMPANY;
    case LegalEntitiesBusinessEntityType.SOLE_PROPRIETORSHIP:
      return KybBusinessType.SOLE_PROPRIETORSHIP;
    case LegalEntitiesBusinessEntityType.C_CORPORATION:
      return KybBusinessType.C_CORPORATION;
    case LegalEntitiesBusinessEntityType.S_CORPORATION:
      return KybBusinessType.S_CORPORATION;
    case LegalEntitiesBusinessEntityType.PARTNERSHIP:
      return KybBusinessType.PARTNERSHIP;
    case LegalEntitiesBusinessEntityType.NONPROFIT:
      return KybBusinessType.NONPROFIT;
    default:
      return undefined;
  }
}